import { render } from "./comp-entity.vue?vue&type=template&id=c0781ae2&ts=true"
import script from "./comp-entity.vue?vue&type=script&lang=ts"
export * from "./comp-entity.vue?vue&type=script&lang=ts"

import "./comp-entity.vue?vue&type=style&index=0&id=c0781ae2&lang=less"

import exportComponent from "/usr/local/share/applications/yushifu-shop-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__